import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function ConfirmModal({
  show,
  title = 'Are you sure?',
  body,
  confirmLabel = 'Yes, continue',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onHide,
}) {
  const [busy, setBusy] = useState(false);

  async function handleConfirm() {
    setBusy(true);
    try {
      await onConfirm();
      onHide();
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide} disabled={busy}>
          {cancelLabel}
        </Button>
        <Button variant={variant} onClick={handleConfirm} disabled={busy}>
          {busy ? 'Working...' : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
